import { Link, useLocation } from 'react-router-dom';

export default function AdminSidebar({ isOpen, onClose }) {
  const location = useLocation();

  const menuItems = [
    { path: '/pheee', icon: 'ri-dashboard-line', label: 'Dashboard' },
    { path: '/pheee/products', icon: 'ri-shopping-bag-line', label: 'Products' },
    { path: '/pheee/orders', icon: 'ri-shopping-bag-line', label: 'Orders' },
    { path: '/pheee/categories', icon: 'ri-folder-line', label: 'Categories' },
    { path: '/pheee/banners', icon: 'ri-image-line', label: 'Banners' },
    // { path: '/pheee/faq', icon: 'ri-question-line', label: 'FAQ' },
    // { path: '/pheee/settings', icon: 'ri-settings-line', label: 'Settings' }
  ];

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 flex-col z-30">
        <div className="p-6 border-b border-gray-200">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-10 h-10 bg-[#EF579A] rounded-lg flex items-center justify-center">
              <i className="ri-store-2-fill text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">SISI</h1>
              <p className="text-xs text-gray-500">Admin Panel</p>
            </div>
          </Link>
        </div>

        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-1">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.path, item.exact)
                      ? 'bg-[#EF579A] text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <i className={`${item.icon} text-xl`}></i>
                  <span className="font-medium text-sm">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-200">
          <Link
            to="/"
            className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            <span className="font-medium text-sm">Back to Store</span>
          </Link>
        </div>
      </aside>

      {/* Mobile Sidebar */}
      <aside
        className={`lg:hidden fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 flex flex-col z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-6 border-b border-gray-200 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer" onClick={onClose}>
            <div className="w-10 h-10 bg-[#EF579A] rounded-lg flex items-center justify-center">
              <i className="ri-store-2-fill text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">SISI</h1>
              <p className="text-xs text-gray-500">Admin Panel</p>
            </div>
          </Link>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-1">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={onClose}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.path, item.exact)
                      ? 'bg-[#EF579A] text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <i className={`${item.icon} text-xl`}></i>
                  <span className="font-medium text-sm">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-200">
          <Link
            to="/"
            onClick={onClose}
            className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            <span className="font-medium text-sm">Back to Store</span>
          </Link>
        </div>
      </aside>
    </>
  );
}
